"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProxyInfoFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcProxyInfoFactory = /** @class */ (function (_super) {
    __extends(ArcProxyInfoFactory, _super);
    function ArcProxyInfoFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcProxyInfoFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcProxyInfoFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcProxyInfoFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcProxyInfoFactory;
}(contracts_1.ContractFactory));
exports.ArcProxyInfoFactory = ArcProxyInfoFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
